import React from 'react';
import PropTypes from 'prop-types';
import classes from './EditBox.module.css';

import { Draggable } from 'react-beautiful-dnd';

const EditBoxPersona = (props) => {
  const { connector, title, persona, index } = props;
  const draggableId = connector
    ? `draggable-${connector}-${title}-${persona.id}`
    : `draggable-${title}-${persona.id}`;
  return (
    <Draggable key={draggableId} draggableId={draggableId} index={index}>
      {(provided) => (
        <span
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
          className={classes.editBoxIconContainer}
        >
          <div
            className="draggable-persona persona-small"
            style={{
              backgroundImage: `url(${persona.picUrl})`,
            }}
          />
        </span>
      )}
    </Draggable>
  );
};

EditBoxPersona.propTypes = {
  connector: PropTypes.string,
  title: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  persona: PropTypes.shape({
    picUrl: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
};

export default EditBoxPersona;
